export default "__VITE_ASSET__mG0k4NTS__"